import { ENDPOINTS } from "../constants";
import { fetchResource } from "../utils/fetch-resource";

export function refreshAccessToken(
  refreshToken: string,
): Promise<{ accessToken: string }> {
  return fetchResource<{ accessToken: string }>(
    `${ENDPOINTS.ACCESS_TOKEN_REFRESH}?refresh_token=${refreshToken}`,
  );
}
